export const minifyString = (
  value: string,
  prefixLen = 6,
  suffixLen = 6,
  divider = '...'
) => {
  return `${value.substring(0, prefixLen)}${divider}${value.substring(
    value.length - suffixLen,
    value.length
  )}`;
};
